import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import { DEFAULT_FIELD_NAMES } from './utils';
var DefaultLabel = DEFAULT_FIELD_NAMES.label,
    DefaultValue = DEFAULT_FIELD_NAMES.value;
export default {
  name: buildComponentName('CascaderMenu'),
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    nodes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    activeValue: {
      type: String,
      default: ''
    },
    level: {
      type: Number,
      default: -1
    },
    expandTrigger: {
      type: String,
      default: 'click'
    },
    visible: {
      type: Boolean,
      default: false
    },
    renderLabel: {
      type: Function,
      default: null
    }
  },
  created: function created() {
    this.enterDelayTimer = null;
  },
  methods: {
    onSelect: function onSelect(e, node) {
      if (node.disabled) {
        return;
      }

      this.$emit('select', e, node);
    },
    onMouseEnter: function onMouseEnter(e, node) {
      var enterDelayTimer = this.enterDelayTimer,
          onSelect = this.onSelect;

      if (enterDelayTimer) {
        clearTimeout(enterDelayTimer);
      }

      this.enterDelayTimer = setTimeout(function () {
        return onSelect(e, node);
      }, 150);
    },
    onMouseLeave: function onMouseLeave() {
      var enterDelayTimer = this.enterDelayTimer;

      if (enterDelayTimer) {
        clearTimeout(enterDelayTimer);
      }
    },
    getItemCls: function getItemCls(node) {
      var _ref;

      var prefixCls = this.prefixCls,
          activeValue = this.activeValue;
      var cls = "".concat(prefixCls, "-item");
      var isActive = activeValue === node[DefaultValue];
      return _ref = {}, _defineProperty(_ref, cls, true), _defineProperty(_ref, "".concat(cls, "-expand"), node.isParent), _defineProperty(_ref, "".concat(cls, "-active"), isActive), _defineProperty(_ref, "".concat(cls, "-disabled"), !!node.disabled), _defineProperty(_ref, "".concat(cls, "-loading"), node.isLoading), _ref;
    },
    renderChildren: function renderChildren() {
      var h = this.$createElement;
      var nodes = this.nodes,
          getItemCls = this.getItemCls,
          expandTrigger = this.expandTrigger,
          renderLabel = this.renderLabel,
          onSelect = this.onSelect,
          onMouseEnter = this.onMouseEnter,
          onMouseLeave = this.onMouseLeave;
      return nodes.map(function (node) {
        var label = node[DefaultLabel];
        var title = node.title || label;
        var on = {
          click: function click(e) {
            onSelect(e, node);
          }
        };

        if (expandTrigger === 'hover') {
          on = _objectSpread({}, on, {
            mouseenter: function mouseenter(e) {
              onMouseEnter(e, node);
            },
            mouseleave: onMouseLeave
          });
        }

        return h("li", _mergeJSXProps([{
          "attrs": {
            "title": title
          }
        }, {
          class: getItemCls(node),
          on: on
        }]), [isFunction(renderLabel) ? renderLabel(_objectSpread({}, node.originNode)) : label]);
      });
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        renderChildren = this.renderChildren;
    return h("ul", {
      "class": "".concat(prefixCls)
    }, [renderChildren()]);
  }
};